import React from "react";
import PropTypes from "prop-types";

const Item = (props) => {
  return (
    <span
      className={"item " + (props.className ? props.className : "")}
      data-testid={props.datatestid}
    >
      {props.value}
    </span>
  );
};

Item.propTypes = {
  className: PropTypes.string,
  datatestid: PropTypes.string,
  value: PropTypes.node,
};

export default Item;
